import React, { useEffect, useState } from "react";
import { useForm } from "react-hook-form";
import { db } from "../../config/Firebase";
import ReactApexChart from "react-apexcharts";
import firebase from "../../config/Firebase";

const DpPage = () => {
  const {
    register,
    handleSubmit,
    watch,
    formState: { errors },
  } = useForm();

  const [data, setData] = useState(null);
  const [date, setDate] = useState(null);
  const [line, setLine] = useState([]);
  const [series, setSeries] = useState(null);
  const [strokes, setStrokes] = useState([]);
  const [options, setOption] = useState({
    chart: {
      height: 350,
    },
    title: {
      text: "Stock Price",
      align: "center",
    },
    stroke: {
      width: [3],
    },
    wick: {
      useFillColor: true,
    },
    xaxis: {
      type: "datetime",
      labels: {
        datetimeUTC: false
      }
    },
    yaxis: {
      tooltip: {
        shared: true,
        intersect: false,
        enabled: true,
      },
    },
    plotOptions: {
      candlestick: {
        colors: {
          upward: '#3C90EB',
          downward: '#DF7D46'
        }
      }
    },
  });

  const formatter = (values) => {
    let result = values?.map((v) => ({
      x: new Date(v.t),
      y: [v.o, v.h, v.l, v.c],
    }));
    return result;
  };

  const getCloudData = (data, line) => {
    const formData = {
      ticker: data.ticker,
      date: data.date,
    };

    var getData = firebase.functions().httpsCallable("GetData");

    getData({ params: formData })
      .then((res) => {
        if (res.data.results) {
          const lines = line.map((v) => ({
            name: "line",
            type: "line",
            data: [
              {
                x: new Date(res.data.results[0].t),
                y: v?.price,
              },

              {
                x: new Date(res.data.results[res.data.results.length - 1].t),
                y: v?.price,
              },
            ],
          }));

          const test = line.map((v) => 2);

          setOption({
            chart: {
              height: 350,
            },
            title: {
              text: "Stock Price",
              align: "center",
            },
            stroke: {
              width: [3, ...test],
            },
            wick: {
              useFillColor: true,
            },
            xaxis: {
              type: "datetime",
              labels: {
                datetimeUTC: false
              }
            },
            yaxis: {
              tooltip: {
                shared: true,
                intersect: false,
                enabled: true,
              },
            },
            plotOptions: {
              candlestick: {
                colors: {
                  upward: '#3C90EB',
                  downward: '#DF7D46'
                }
              }
            },
          });

          setSeries([
            ...lines,

            {
              name: "candle",
              type: "candlestick",
              data: formatter(res?.data?.results),
            },
          ]);
        } else {
          setSeries([
            {
              name: "line",
              type: "line",
              data: [
                {
                  x: "",
                  y: "",
                },

                {
                  x: "",
                  y: "",
                },
              ],
            },

            {
              name: "line",
              type: "line",
              data: [
                {
                  x: "",
                  y: "",
                },

                {
                  x: "",
                  y: "",
                },
              ],
            },

            {
              name: "candle",
              type: "candlestick",
              data: [],
            },
          ]);
        }
      })
      .catch((err) => console.log(err));
  };

  const onSubmit = (data) => {
    const test = data.date.concat("-", data.ticker);
    console.log(test)
    db.collection("dp")
      .doc(test)
      .get()
      .then((querySnapshot) => {
        if (querySnapshot.data() === undefined) {
          const line = [];
          getCloudData(data, line);

          console.log("i am running");
        } else {
          const line = querySnapshot.data().data;
          getCloudData(data, line);

        }
      });
  };

  useEffect(() => {
    var today = new Date();
    var dd = String(today.getDate()).padStart(2, "0");
    var mm = String(today.getMonth() + 1).padStart(2, "0"); //January is 0!
    var yyyy = today.getFullYear();

    today = yyyy + "-" + mm + "-" + dd;
    setDate(today);

    const data = {
      date: today,
      ticker: "AAPL",
    };

    db.collection("dp")
      .doc(`${today}-AAPL`)
      .get()
      .then((querySnapshot) => {
        if (querySnapshot.data() === undefined) {
          const line = [];
          getCloudData(data, line);
        } else {
          const line = querySnapshot.data().data;
          getCloudData(data, line);
        }
      });
  }, []);


  return (
    <div className="bg-light-2 pt-5 mt-5" style={{ fontSize: `0.8rem` }}>
      <section className="pt-5 pb-5">
        <div className="container mb-5">
          <form onSubmit={handleSubmit(onSubmit)}>
            <div className="d-flex flex-column flex-md-row justify-content-center">
              <div className="mr-md-auto">
                <input
                  {...register("ticker", { required: true })}
                  className="form-control"
                  type="text"
                  defaultValue="AAPL"
                  placeholder="Ticker"
                />
              </div>
              <div className="mr-md-4 my-3 my-md-0">
                <input
                  className="form-control"
                  type="date"
                  name="date"
                  defaultValue={date}
                  {...register("date", { required: true })}
                />
              </div>
              <div className="px-0 col-12 col-md-3 col-lg-2">
                <button
                  type="submit"
                  className="btn btn-call btn-block rounded-sm"
                >
                  Search
                </button>
              </div>
            </div>
          </form>
          <div>
            <div className="bg-white p-3 mt-4" id="chart">
              {series === null ? (
                <>loading</>
              ) : (
                <ReactApexChart options={options} series={series} />
              )}
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};

export default DpPage;
